import { Link } from "react-router-dom";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";

export default function NotFound() {
  return (
    <>
      <Navigation />
      <main className="container-narrow section-pad" style={{ textAlign: "center" }}>
        <div className="se-badge mb-6" style={{ margin: "0 auto" }}>404</div>
        <h1 className="type-display-large mb-4">Page not found</h1>
        <p className="type-body-large mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has moved.
        </p>
        <Link to="/" className="btn-primary">Return home</Link>
      </main>
      <Footer />
    </>
  );
}
